export function initInvestorStickyNavScroll(navSelector, linkSelector) {
    const nav = document.querySelector(navSelector);
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const stickyNavQuery = window.matchMedia('(min-width: 768px)');
    const behavior = prefersReduced ? 'auto' : 'smooth';

    const getScrollOffset = () => {
        if (!nav) return 16;
        return stickyNavQuery.matches ? nav.offsetHeight + 8 : 16;
    };

    document.querySelectorAll(linkSelector).forEach((link) => {
        link.addEventListener('click', (event) => {
            const hash = link.getAttribute('href');
            if (!hash || hash === '#') return;

            const target = document.querySelector(hash);
            if (!target) return;

            event.preventDefault();

            const top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();

            window.scrollTo({
                top: Math.max(0, top),
                behavior,
            });

            history.replaceState(null, '', hash);
        });
    });
}
